/**
 * 問い合わせAPIを呼び出す共通関数
 *
 * 例: sendInquiry({ type: "projects", id: 123, body: { user_id: 1 } })
 *     → /api/projects/123/inquiry にPOSTリクエスト
 *
 * @param {Object} params
 * @param {string} params.type - エンティティ名（例: "projects", "jobs"）
 * @param {number|string} params.id - 対象ID
 * @param {Object} [params.body={}] - 追加で送りたいデータ（任意）
 * @returns {Promise<{ success: boolean, error?: string }>}
 */
export const sendInquiry = async ({ type, id, body = {}, csrfToken }) => {
  try {
    // APIにPOSTリクエスト
    const res = await fetch(`/api/${type}/${id}/inquiry`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify(body),
    });

    // 成功時: { success: true } を返す
    if (res.ok) {
      return { success: true };
    } else {
      // APIエラー時: エラーメッセージ付きで返す
      return {
        success: false,
        error: "送信に失敗しました。再度お試しください。",
      };
    }
  } catch (e) {
    // 通信エラー時: エラーメッセージ付きで返す
    return { success: false, error: "エラーが発生しました。" };
  }
};
